import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import moment from 'moment';

import { Panel, PanelHeader, PanelBody } from '../../components/panel/panel.jsx';
import withNotification from '../../components/HOCNotification/HOCNotification.component';
import Services from '../../services/service';
import {BASE_URL} from '../../config/constants';
import Pdf from 'react-to-pdf';

const ref = React.createRef();

class DetailComplaint extends Component {
  constructor(props) {
    super(props);
    this.state = {
      dataComplaint: [],
    };

    this.selectedData = window.history.state.state.selectedData;
  };

  componentDidMount(){
    this.getDataComplaint();
  };

  renderBreadcrumb = () => (
    <div>
      <ol className="breadcrumb float-xl-right">
        <li className="breadcrumb-item"><Link to="/">Home</Link></li>
        <li className="breadcrumb-item"><Link to="/reporting/complaint-data-report-list">Komplain</Link></li>
        <li className="breadcrumb-item active">Detail Komplain</li>
      </ol>
      <h1 className="page-header">Detail Komplain </h1>
    </div>
  );

  getDataComplaint = () => {
    const param = { params: { id: this.selectedData._id }};
    Services.getComplaintDetail(param)
      .then(res => {
        this.setState({dataComplaint: res});
      })
      .catch(err => console.log(err))
  };

  renderTitleReport = () => {
    const { dataComplaint } = this.state;
    return (
      <div className="col-xl-12">
        <Panel>
          <PanelHeader noButton={true}>
            <div className="d-flex justify-content-xl-between">
              <h5>{dataComplaint.title}</h5>
              <div className="d-flex justify-content-xl-between" style={{width: "10%"}}>
              </div>
            </div>
          </PanelHeader>
        </Panel>
      </div>
    )
  };

  renderDetailReportTable = () => {
    const { dataComplaint } = this.state;
    return (
      <div className="col-xl-12">
        <Panel>
          <PanelHeader noButton={true}>
            <div className="d-flex justify-content-xl-between">
              <h5>Detil Laporan</h5>
              <div className="d-flex justify-content-xl-between" style={{width: "10%"}}>
              </div>
            </div>
          </PanelHeader>
          <PanelBody>
            <div className="table-responsive">
              <table className="table table-striped m-b-0">
                <thead>
                  <tr>
                    <th>Tanggal Laporan</th>
                    <th>Ditujukan</th>
                    <th>Pelaporan</th>
                    <th>Judul</th>
                    <th>Lokasi</th>
                    <th>Prioritas</th>
                    <th>Status</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>{moment(dataComplaint.createDate).format('DD-MM-YYYY')}</td>
                    <td>{dataComplaint.sendToName}</td>
                    <td>{dataComplaint.createByName}</td>
                    <td>{dataComplaint.title}</td>
                    <td>{dataComplaint.location}</td>
                    <td>{dataComplaint.priority}</td>
                    <td>{dataComplaint.status}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </PanelBody>
        </Panel>
      </div>
    )
  };

  renderAsset = () => {
    const { dataComplaint } = this.state;
    const assetName = dataComplaint.assetName ? dataComplaint.assetName : ''
    return (
      <div className="col-xl-12">
      <Panel>
        <PanelHeader noButton={true}>
        <div className="d-flex justify-content-xl-between">
          <h5>Asset</h5>
          <div className="d-flex justify-content-xl-between" style={{width: "10%"}}>
          </div>
        </div>
        </PanelHeader>
        <PanelBody>
          <div className="table-responsive">
          <input name="report" readOnly className="form-control" type="text" defaultValue={assetName}/>
          </div>
        </PanelBody>
      </Panel>
      </div>
    );
  };

  renderReport = () => (
    <div className="col-xl-12">
    <Panel>
      <PanelHeader noButton={true}>
      <div className="d-flex justify-content-xl-between">
        <h5>Isi Laporan</h5>
      </div>
      </PanelHeader>
      <PanelBody>
        <div className="table-responsive">
        <input name="report" readOnly className="form-control" type="text" defaultValue={this.state.dataComplaint.content}/>
        </div>
      </PanelBody>
    </Panel>
    </div>
  );

  renderReportPhoto = () => (
    <div className="col-xl-12">
    <Panel>
      <PanelHeader noButton={true}>
      <div className="d-flex justify-content-xl-between">
        <h5>Foto Laporan</h5>
      </div>
      </PanelHeader>
      <PanelBody>
        <div className="table-responsive">
          {this.renderEvidenceData(this.state.dataComplaint.file)}
        </div>
      </PanelBody>
    </Panel>
    </div>
  );

  renderEvidenceData = (evidenceData) => {
    if(evidenceData !== undefined){
      return (
        <div id="gallery" className="gallery">
          {evidenceData.map((item, idx) => {
            return (
              <div key={idx} className={'image pull-left'}>
                <div>
                  <img 
                    src={`${BASE_URL}/complaint-data-file/${item}`}
                    style={{ maxWidth: "800", maxHeight: '90%', objectFit: 'cover'}}
                    alt=''
                  />
                </div>
              </div>
            )
          })}
        </div>
      )
    } else {
      return null;
    }
  };

  renderOfficerReportTable = () => {
    const { dataComplaint } = this.state;
    if (dataComplaint.statusImprovement !== undefined) {
      return (
        <div className="col-xl-12">
          <Panel>
            <PanelHeader noButton={true}>
              <div className="d-flex justify-content-xl-between">
                <h5>Status Perbaikan</h5>
                <div className="d-flex justify-content-xl-between" style={{width: "10%"}}>
                </div>
              </div>
            </PanelHeader>
            <PanelBody>
              <div className="table-responsive">
                <table className="table table-striped m-b-0">
                  <thead>
                    <tr>
                      <th>Mulai</th>
                      <th>Selesai</th>
                      <th>SLA</th>
                      <th>Status</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>{moment(dataComplaint.statusImprovement.start).format('DD-MM-YYYY')}</td>
                      <td>{moment(dataComplaint.statusImprovement.end).format('DD-MM-YYYY')}</td>
                      <td>{dataComplaint.statusImprovement.sla}</td>
                      <td>{dataComplaint.statusImprovement.status}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </PanelBody>
          </Panel>
        </div>
      );
    }
  };

  renderOfficerReport = () => {
  let no = 0;
  const { dataComplaint } = this.state;
    return (
      <div className="col-xl-12">
      <Panel>
        <PanelHeader noButton={true}>
        <div className="d-flex justify-content-xl-between">
          <h5>Petugas yang memperbaiki</h5>
          <div className="d-flex justify-content-xl-between" style={{width: "10%"}}>
          </div>
        </div>
        </PanelHeader>
        <PanelBody>
          <div className="table-responsive">
            <table className="table table-striped m-b-0">
              <thead>
                <tr>
                  <th>No</th>
                  <th>Petugas</th>
                  <th>Status</th>
                </tr>
              </thead>
              <tbody>
                {!!dataComplaint.officerList && dataComplaint.officerList.map((item, index) => {
                  no++;
                  return (
                    <tr key={index}>
                      <th>{no}</th>
                      <th>{item.name}</th>
                      <th>{item.jobStatus}</th>
                    </tr>
                  );
                })}

              </tbody>
            </table>
          </div>
        </PanelBody>
      </Panel>
      </div>
    );
  }
  
  renderHistory = () => { 
    const { dataHistory } = this.state.dataComplaint;
    if(dataHistory !== undefined) {
    return (
      <div className="col-xl-12">
        <Panel>
          <PanelHeader noButton={true}>
            <div className="d-flex justify-content-xl-between">
              <h5>History</h5>
              <div className="d-flex justify-content-xl-between" style={{width: "10%"}}>
              </div>
            </div>
          </PanelHeader>
          <ul className="timeline">
          {dataHistory.map((item, idx) => {
            return (
              <li key={idx}>
                <div className="timeline-time">
                  <span className="date">{moment(item.date).utc().format('DD MMMM YYYY')}</span>
                  <span className="time">{moment(item.date).utc().format('HH:mm')}</span>
                </div>
                <div className="timeline-icon">
                  <Link to="/extra/timeline">&nbsp;</Link>
                </div>
                <div className="timeline-body">
                  <div className="timeline-header">
                    <span className="username">{item.officer}</span>
                  </div>
                  <div className="timeline-content">
                    <h4 className="template-title">
                      {item.notes}
                    </h4>
                    <p className="m-t-20">
                      <img src={`${BASE_URL}/complaint-data-file/${item.evidence[0]}`} alt="evidence"
                        style={{ maxHeight: "200px"}}
                      />
                    </p>
                  </div>
                </div>
              </li>
            )
          })}
          </ul>
        </Panel>
      </div>
    )}
  }

  renderPrintButton = () => (
    <Pdf targetRef={ref} filename="Detail Complaint.pdf" x={-3} y={5} scale={0.75}>
      {({ toPdf }) => 
        <button className="btn btn-success" onClick={toPdf}> Print Detail </button>
      }
    </Pdf>
  )

  render(){
    const { dataComplaint } = this.state;

    return(
      <div>
        {this.renderBreadcrumb()}
          <div className="row" ref={ref}>
            {this.renderTitleReport()}
            {this.renderDetailReportTable()}
            {dataComplaint?.assetName && this.renderAsset()}
            {this.renderReport()}
            {this.renderReportPhoto()}
            {this.renderOfficerReport()}
            {this.renderOfficerReportTable()}
            {this.renderHistory()}
          </div>
          <div style={{ textAlign: 'center' }}>
            {this.renderPrintButton()}
          </div>
      </div>
    )
  }
}

export default withNotification(DetailComplaint);